function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBaseCorp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1264_8350)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 70,
    fill: "#E4F2E6",
    style: {
      fill: "#E4F2E6",
      fill: "color(display-p3 0.8941 0.9490 0.9020)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6374 6.29979C18.3317 1.63312 25.0675 1.63314 27.7618 6.2998L53.8292 51.4498C56.5235 56.1165 53.1556 61.9498 47.767 61.9498H-4.36777C-9.75637 61.9498 -13.1242 56.1165 -10.4299 51.4498L15.6374 6.29979Z",
    fill: "#C2E6D1",
    style: {
      fill: "#C2E6D1",
      fill: "color(display-p3 0.7608 0.9020 0.8196)",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1264_8350"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 70,
    rx: 10,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBaseCorp);
export default __webpack_public_path__ + "static/media/base-corp.a368843c7e9f2bed168d065f7f5cd990.svg";
export { ForwardRef as ReactComponent };